import { LogManager } from "aurelia-framework";

const logger = LogManager.getLogger("FileLoader");

export class FileLoader {
  // this is needed to inject all images for build
  public rootImages = this.importAll(
    // @ts-ignore
    require.context("../assets/images/gallery", false, /\.(png|jpe?g|gif|svg)$/)
  );
  public articleImages = this.importAll(
    // @ts-ignore
    require.context(
      "../assets/images/articles",
      false,
      /\.(png|jpe?g|gif|svg)$/
    )
  );

  private imageKeys: string[] = [
    ...Object.keys(this.rootImages),
    ...Object.keys(this.articleImages),
  ];

  private importAll(r: any) {
    const images = {};
    r.keys().forEach((key) => (images[key] = r(key)));
    return images;
  }

  public getFile(fileName: string): string {
    const matchedImage = this.imageKeys.find((key) => {
      return (
        key.indexOf("/" + fileName + ".svg") >= 0 ||
        key.indexOf("/" + fileName + ".png") >= 0 ||
        key.indexOf("/" + fileName + ".jpg") >= 0 ||
        key.indexOf("/" + fileName + ".jpeg") >= 0 ||
        key.indexOf("/" + fileName + ".pdf") >= 0
      );
    });
    if (matchedImage) {
      if (this.rootImages[matchedImage]) {
        return this.rootImages[matchedImage];
      }
    } else {
      logger.warn(" > Failed to load image ", fileName, this.rootImages);
    }
  }

  public log(): void {
    console.log(" ::>> check my images >>>>> ", {
      rootImages: this.rootImages,
      articleImages: this.articleImages,
    });
  }
}
